import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Nav, Row, Tab, Alert, Spinner } from "react-bootstrap";
import TableData from "./component/tableData";
import { useSelector } from "react-redux";
import { get, updateToken } from "../../../helpers/api_helper";
import Pagination from "../../../components/Pagination";

const Accounting = () => {
  const token = useSelector((state) => state.login.token);
  const [AccountingData, setAccountingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalEarnings, setTotalEarnings] = useState(0);

  const fetchAccounting = useCallback(
    async (page = 1) => {
      setLoading(true);
      setError(null);

      try {
        const response = await get(
          `/pay/fetch?page=${page}&limit=${itemsPerPage}`
        );
        if (response?.success) {
          setAccountingData(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 0);
        } else {
          setError(response.message || "Failed to fetch content");
        }
      } catch (error) {
        setError("An error occurred while fetching data.");
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage]
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const fetchTotalEarnings = useCallback(async () => {
    try {
      const response = await get(`/graph/total-earnings`);
      if (response?.success) {
        setTotalEarnings(response?.data);
      } else {
        setError(response.message || "Failed to fetch total earnings");
      }
    } catch (error) {
      setError("An error occurred while fetching total earnings.");
    }
  }, []);

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchAccounting(currentPage);
      fetchTotalEarnings();
    }
  }, [token, fetchAccounting, fetchTotalEarnings, currentPage]);

  return (
    <>
      <section className="Accounting position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-start sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h4 className="m-0 fw-bold">Accounting Details</h4>
                  <p className="m-0 text-muted py-1">
                    It is a long established fact that a reader will be
                    distracted by the readable
                  </p>
                </div>
                <div className="right d-flex align-items-center flex-wrap gap-10">
                  <div className="cardEarning p-lg-4 p-3 bg-white d-flex align-items-center gap-10">
                    <div className="content">
                      <p className="text-muted m-0 py-2">Your Total Earning</p>
                      <h4 className="fw-normal m-0">${totalEarnings.toFixed(2)}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="Transactions"
              >
                <Nav
                  variant="pills"
                  className="transparentBtn-Tab underlineTab py-2 gap-10"
                >
                  <Nav.Item>
                    <Nav.Link
                      eventKey="Transactions"
                      className="p-0 bg-transparent position-relative px-2"
                    >
                      Transactions
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="Transactions">
                    <div className="commonTable">
                      {loading ? (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: "100px" }}
                        >
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </div>
                      ) : error ? (
                        <Alert variant="danger">{error}</Alert>
                      ) : (
                        <div className="commonTable scrollable-table-container">
                          <TableData AccountingData={AccountingData} />
                          {totalPages > 1 && (
                            <Pagination
                              currentPage={currentPage}
                              totalPages={totalPages}
                              onPageChange={handlePageChange}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Accounting;
